import React, { useEffect, useState } from 'react'
import Offers from '../Allmenus/FirstMenu/Offers'
import Reservation from '../Allmenus/FirstMenu/Reservation'
import Privateevent from '../Allmenus/Thrdmenu/Privateevent'
import Bredcrumb from '../Bredcrumb/Main'
import Img from '../../assets/images/background/banner-image-2.jpg'
import { getOrganisationCategories } from '../../services/categoryService'
import MenuCategorySection from './MenuCategorySection'

function Menuthree() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getOrganisationCategories();
        const pizza = data.find(c => c.slug === 'pizza');
        const rest = data.filter(c => c.slug !== 'pizza');
        setCategories(pizza ? [pizza, ...rest] : data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <Bredcrumb subtitle="Naš Meni" title="UKUSNO I NEVEROVATNO" Img={Img} className="menuthree-banner" />
      
      {loading ? (
        <div className="auto-container centered" style={{ padding: '50px 0' }}>
            <div className="sec-title centered">
                <h2>Učitavanje menija...</h2>
            </div>
        </div>
      ) : (
        categories.length > 0 ? (
          categories.map((category, index) => (
            <MenuCategorySection key={category.id} category={category} index={index} />
          ))
        ) : (
          <div className="auto-container centered" style={{ padding: '50px 0' }}>
             <div className="sec-title centered">
                <h2>Meni će biti dostupan uskoro.</h2>
             </div>
          </div>
        )
      )}

      <Privateevent />
      <Offers />
      <Reservation />
    </>
  )
}

export default Menuthree
